import { ElMessage } from 'element-ui/types/message';
import { ElMessageBox } from 'element-ui/types/message-box';
import { AxiosInstance, AxiosResponse } from 'axios';

export default class Fn {
    constructor(
        public message: ElMessage,
        public msgbox: ElMessageBox,
        public http: AxiosInstance,
        public utils: { [key: string]: any }
    ) {}

    public httpGet(url: string, param: any): any {
        const getUrl = (param != null || param !== '') ? url + '?' + param : url
        this.http.get(getUrl).then((res: AxiosResponse) => {
            if (res.data.code === 1) {
                return res;
            } else {
                this.error(res.data.msg)
            }
        })
    }

    public httpPost(url: string, param: any): any {
        this.http.post(url, param).then((res: AxiosResponse) => {
            if (res.data.code === 1) {
                return res;
            } else {
                this.error(res.data.msg)
            }
        })
    }

    public httpDelete(url: string, param: any): any {
        this.http.delete(url, param).then((res: AxiosResponse) => {
            if (res.data.code === 1) {
                return res;
            } else {
                this.error(res.data.msg)
            }
        })
    }

    public uuid(): string {
        return this.utils.id.create();
    }

    public msg(msg: string): void {
        this.message.info(msg);
    }

    public error(msg: string): void {
        this.message.error(msg);
    }

    public warning(msg: string): void {
        this.message.warning(msg);
    }

    public msgBox(msg: string, title: string): void {
        this.msgbox.confirm(msg, title);
    }

    public alert(message: string): void {
        alert(message);
    }

    public confirm(message: string): void {
        confirm(message);
    }

    public log(message: any) :void {
        console.log(message);
    }

    public infoLog(message: any): void {
        console.info(message);
    }

    public errorLog(message: any): void {
        console.error(message);
    }

    public warnLog(message: any): void {
        console.warn(message);
    }

    public strToNum(source: string): number {
        let target: number = 0;
        try {
            target = parseInt(source, 10);
        } catch (e) {
            throw new Error('类型转换失败');
        }
        return target;
    }

    public strToBool(source: string): boolean {
        let result: boolean = false;
        if (source === '1') {
            result = true;
        } else if (source === '0') {
            result = false;
        } else {
            throw new Error('参数不符，类型转换失败');
        }
        return result;
    }

    public jsonToObject(souce: string): any {
        return JSON.parse(souce);
    }

    public objToJson(souce: object): string {
        return JSON.stringify(souce);
    }

    public preFillUp(value: string, lenth: number, identifier: string) : string{
        value = Array(lenth + 1).join(identifier) + value;
        return value.slice(-lenth);
    }

    public random(max: number, min: number): number {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    public toRMBNumber(money: string): string {
        let cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字
        let cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
        let cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
        let cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
        let cnInteger = "整"; //整数金额时后面跟的字符
        let cnIntLast = "元"; //整型完以后的单位
        let maxNum = 999999999999999.9999; //最大处理的数字
        let IntegerNum; //金额整数部分
        let DecimalNum; //金额小数部分
        let ChineseStr = ""; //输出的中文金额字符串
        let parts; //分离金额后用的数组，预定义
        if (money === '') {
            return "";
        }
        let newMoney: number = parseFloat(money);
        if (newMoney >= maxNum) {
            throw new Error('超出最大处理数字');
        }
        if (newMoney === 0) {
            ChineseStr = cnNums[0] + cnIntLast + cnInteger;
            return ChineseStr;
        }
        money = newMoney.toString(); //转换为字符串
        if (money.indexOf(".") == -1) {
            IntegerNum = money;
            DecimalNum = '';
        } else {
            parts = money.split(".");
            IntegerNum = parts[0];
            DecimalNum = parts[1].substr(0, 4);
        }
        if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
            let zeroCount = 0;
            let IntLen = IntegerNum.length;
            for (let i = 0; i < IntLen; i++) {
                let n = IntegerNum.substr(i, 1);
                let p = IntLen - i - 1;
                let q = p / 4;
                let m = p % 4;
                if (n == "0") {
                    zeroCount++;
                } else {
                    if (zeroCount > 0) {
                        ChineseStr += cnNums[0];
                    }
                    zeroCount = 0; //归零
                    ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                }
                if (m == 0 && zeroCount < 4) {
                    ChineseStr += cnIntUnits[q];
                }
            }
            ChineseStr += cnIntLast;
            //整型部分处理完毕
        }
        if (DecimalNum != '') { //小数部分
            let decLen = DecimalNum.length;
            for (let i = 0; i < decLen; i++) {
                let n = DecimalNum.substr(i, 1);
                if (n != '0') {
                    ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
                }
            }
        }
        if (ChineseStr == '') {
            ChineseStr += cnNums[0] + cnIntLast + cnInteger;
        } else if (DecimalNum == '') {
            ChineseStr += cnInteger;
        }
        return ChineseStr;
    }

    public isEmpty(param: any): boolean {
        if (typeof param === 'undefined' || param == null || param === '') {
            return true;
        } else if (param instanceof Array) {
            return param.length === 0;
        } else {
            return false;
        }
    }

    public isNotEmpty(param: any): boolean {
        if (typeof param === 'undefined' || param == null || param === '') {
            return false;
        } else if (param instanceof Array) {
            return param.length !== 0;
        } else {
            return true;
        }
    }

    public isNaN(param: number, def: number): number {
        if (isNaN(param)) {
            return def;
        } else {
            return param;
        }
    }

    public decode(param: string, safe: boolean): object {
        let result: object = {};
        if (param === '' && safe) {
            result = {};
        } else if (param === '' && !safe) {
            throw new Error('数据为空')
        } else {
            result = JSON.parse(param);
        }
        return result;
    }

    public encode(param: object): string {
        return JSON.stringify(param);
    }
}
